<template>
  <div class="tpp-page">
    <zhuomuniao-ops-nav active-path="/pages/tpp/zhuomuniao/orders" :platform-id="platformId" />
    <section class="tpp-panel" v-loading="loading">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">订单详情</h2>
          <p class="tpp-muted">{{ order.orderId || '-' }} · {{ order.stateName || order.state || '-' }}</p>
        </div>
        <div>
          <el-button size="small" @click="goZhuomuniao('/pages/tpp/zhuomuniao/orders')">返回列表</el-button>
          <el-button v-if="order.canRetrySync" type="primary" size="small" :loading="retrying" @click="retry">补推同步</el-button>
        </div>
      </div>
      <el-alert title="只读履约字段。不可标记完成或改对方上门状态。补推仅同步 createOrder。" type="info" :closable="false" show-icon style="margin-bottom:16px" />
      <el-descriptions :column="2" border>
        <el-descriptions-item label="本地订单号">{{ order.orderId }}</el-descriptions-item>
        <el-descriptions-item label="对方订单号">{{ order.externalOrderId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="小区">{{ order.communityName || order.communityId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="产品">{{ order.productName || order.productId }}</el-descriptions-item>
        <el-descriptions-item label="预约时间">{{ order.appointmentTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ order.personName }} {{ maskZmnPhone(order.personTel) }}</el-descriptions-item>
        <el-descriptions-item label="师傅">{{ order.masterName || '-' }} {{ maskZmnPhone(order.masterPhone) }}</el-descriptions-item>
        <el-descriptions-item label="预付/实收">{{ order.prepayAmount }} / {{ order.receivedAmount || '0.00' }}</el-descriptions-item>
        <el-descriptions-item label="服务地址" :span="2">{{ order.address || '-' }}</el-descriptions-item>
        <el-descriptions-item label="退款">{{ order.refundState || '-' }}<span v-if="order.refundAmount"> / ¥{{ order.refundAmount }}</span></el-descriptions-item>
      </el-descriptions>
    </section>
    <section class="tpp-panel">
      <h3 class="tpp-panel__title">履约链路</h3>
      <p class="tpp-tip">本平台收款后同步上门，不是导购点击归因。</p>
      <el-steps direction="vertical" :active="(order.attribution || []).length" finish-status="success">
        <el-step v-for="item in (order.attribution || [])" :key="item.code" :title="item.title" :description="formatAttr(item)" />
      </el-steps>
    </section>
    <section class="tpp-panel">
      <h3 class="tpp-panel__title">支付请求</h3>
      <el-table :data="order.payRequests || []" border style="margin-top:12px" empty-text="暂无支付记录">
        <el-table-column prop="amountType" label="类型" width="90" />
        <el-table-column prop="amountYuan" label="金额" width="90" />
        <el-table-column prop="state" label="状态" width="90" />
        <el-table-column prop="extOrderId" label="支付单号" min-width="140" />
        <el-table-column prop="createTime" label="时间" width="160" />
      </el-table>
    </section>
    <section class="tpp-panel">
      <h3 class="tpp-panel__title">进度时间线</h3>
      <el-timeline style="margin-top:12px">
        <el-timeline-item v-for="(item, index) in (order.timeline || [])" :key="`${item.title}-${index}`" :timestamp="item.time || ''" placement="top">
          <p style="margin:0 0 4px;font-weight:600">{{ item.title }}</p>
          <p class="tpp-muted" style="margin:0">{{ item.description }}</p>
        </el-timeline-item>
      </el-timeline>
      <p v-if="!(order.timeline && order.timeline.length)" class="tpp-muted">暂无进度事件</p>
    </section>
  </div>
</template>
<script>
import ZhuomuniaoOpsNav from './zhuomuniaoNav.vue'
import { zhuomuniaoOpsMixin } from './zhuomuniaoOpsMixin'
import { getOrder, retrySyncOrder } from '@/api/life/homeServiceApi'
import { maskZmnPhone, zmnPayload } from '@/api/tpp/zhuomuniaoOpsApi'
import '../tpp.scss'
export default {
  name: 'ZhuomuniaoOrderDetail',
  components: { ZhuomuniaoOpsNav },
  mixins: [zhuomuniaoOpsMixin],
  data() { return { loading: false, retrying: false, orderId: '', order: {} } },
  async created() {
    this.orderId = String(this.$route.query.orderId || '')
    if (!this.orderId) { this.$message.error('缺少订单号'); this.goZhuomuniao('/pages/tpp/zhuomuniao/orders'); return }
    if (await this.ensureZhuomuniaoPlatform()) this.load()
  },
  methods: {
    maskZmnPhone,
    formatAttr(item) {
      const value = item.value || ''
      const detail = item.detail || ''
      return detail ? `${value}｜${detail}` : value
    },
    async load() {
      this.loading = true
      try { this.order = zmnPayload(await getOrder({ orderId: this.orderId })) || {} }
      catch (e) { this.$message.error(e.message || '订单加载失败') }
      finally { this.loading = false }
    },
    async retry() {
      try {
        await this.$confirm(`确认补推同步订单「${this.orderId}」？`, '补推同步', { type: 'warning' })
        this.retrying = true
        const res = await retrySyncOrder({ orderId: this.orderId })
        const data = res.data || res
        this.$message.success(`补推完成：${data.stateName || data.state || '已提交'}`)
        await this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '补推失败') }
      finally { this.retrying = false }
    }
  }
}
</script>
